import React from 'react';
import PropTypes from 'prop-types';
import RetiredPrinterCard from './RetiredPrinterCard';
import style from './IdCardPrinterBoard.module.sass';

// Deliberately not a 4th board column: retirement is a dead end, not another
// step in the inventory -> school -> delivered flow, so it lives in its own
// section below the board instead of competing for space in that row.
const OutOfCommissionSection = ({ printers, busyIds, onRestore }) => (
  <div className={style.retiredSection}>
    <div className={style.columnHeader}>
      Out of Commission / For Parts
      <span className={style.columnCount}>{printers.length}</span>
    </div>
    <p className={style.columnHint}>
      Printers pulled from rotation. Letters aren&apos;t assigned here, so these are identified by model and
      serial number only.
    </p>

    <div className={style.retiredGrid}>
      {printers.length === 0 && <div className={style.emptyState}>Nothing out of commission right now.</div>}

      {printers.map((printer) => (
        <RetiredPrinterCard
          key={printer.id}
          printer={printer}
          disabled={busyIds.includes(`printer-${printer.id}`)}
          onRestore={onRestore}
        />
      ))}
    </div>
  </div>
);

OutOfCommissionSection.propTypes = {
  printers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
  busyIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onRestore: PropTypes.func.isRequired,
};

export default OutOfCommissionSection;
